import { render, staticRenderFns } from "./bin.vue?vue&type=template&id=a5808016&"
import script from "./bin.vue?vue&type=script&lang=ts&"
export * from "./bin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports